export default __webpack_public_path__ + "static/media/icon_imaging_pressed..e5f3bafb.svg";